const Constants = {
  bgColor: "#192231",
}

export default Constants;